import { type FlightsMetaDto } from '@clients/FlightApi';

export enum FlightFilters {
    Price = 'price',
    StopCount = 'stopCount',
    Time = 'time',
    Duration = 'duration',
    Stops = 'stops',
    Airline = 'airline',
    ClassOfService = 'classOfService',
    Labels = 'labels',
    FlightNumber = 'flightNumber',
    Baggage = 'baggage',
}

export class FlightServiceException {
    message: string;
    showAndReturn = false;

    constructor(message: string, showAndReturn?: boolean) {
        this.message = message;
        this.showAndReturn = !!showAndReturn;
    }
}

export interface FlightFiltersData {
    key: FlightFilters;
    meta: FlightsMetaDto;
}
